exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-QuestionChoice-___QuestionChoice__button___3ztUr {\n  height: 100%;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.src-pc-components-organisms-QuestionChoice-___QuestionChoice__normal___3brIP {\n  background-color: #F3F7F4;\n}\n\n.src-pc-components-organisms-QuestionChoice-___QuestionChoice__correct___2R5dk {\n  background-color: #5A84F8;\n}\n\n.src-pc-components-organisms-QuestionChoice-___QuestionChoice__transparent___XiVW8 {\n  opacity: 0.4;\n  background-color: #F3F7F4;\n}\n", ""]);

// exports
exports.locals = {
	"button": "src-pc-components-organisms-QuestionChoice-___QuestionChoice__button___3ztUr",
	"normal": "src-pc-components-organisms-QuestionChoice-___QuestionChoice__normal___3brIP",
	"correct": "src-pc-components-organisms-QuestionChoice-___QuestionChoice__correct___2R5dk",
	"transparent": "src-pc-components-organisms-QuestionChoice-___QuestionChoice__transparent___XiVW8"
};